import { render, staticRenderFns } from "./purchaseOrders.vue?vue&type=template&id=2a3b75d7&"
import script from "./purchaseOrders.vue?vue&type=script&lang=js&"
export * from "./purchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrders.vue?vue&type=style&index=0&id=2a3b75d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports